import React from 'react';
import DocPage from './DocPage';

const sections = [
  {
    id: 'overview',
    title: 'Overview',
    body: (
      <p>
        This policy describes how Blends Pet Solutions Private Ltd ("PetCart", "we", "us") collects
        and uses your personal information when you use our services, visit our facilities, or
        interact with us online at this website.
      </p>
    ),
  },
  {
    id: 'collection',
    title: 'What we collect',
    body: (
      <>
        <p>
          <strong>Contact and enquiry details</strong> you share through our forms — name, phone,
          email, and message content — so we can respond to boarding, daycare, grooming, or other
          requests.
        </p>
        <p>
          <strong>Booking and pet details</strong> you provide for services — breed, age, medical
          notes, dietary preferences, and related care information.
        </p>
        <p>
          <strong>Website usage data</strong> when you visit our site — pages viewed, approximate
          location derived from IP, device/browser type, and referral source. If you accept
          analytics cookies, this may include Google Analytics measurement and Google Ads /
          Google Tag Manager advertising measurement (for example conversion attribution).
        </p>
      </>
    ),
  },
  {
    id: 'processors',
    title: 'How we store and process it',
    body: (
      <>
        <p>
          Enquiry form submissions are processed securely via Supabase (cloud infrastructure) so our
          team can follow up with you. Analytics and advertising measurement, when consented, are
          processed by Google LLC (Google Analytics, Google Tag Manager, and Google Ads).
        </p>
        <p>
          We retain enquiry and booking information only as long as needed to provide services,
          meet legal obligations, or resolve disputes, then delete or anonymise it.
        </p>
      </>
    ),
  },
  {
    id: 'usage',
    title: 'How we use it',
    body: (
      <p>
        To deliver the services you've booked, respond to enquiries, communicate about your pet's
        stay, improve our website and operations, and meet legal requirements. We do not sell your
        personal information.
      </p>
    ),
  },
  {
    id: 'cookies',
    title: 'Cookies and tracking',
    body: (
      <p>
        Essential cookies keep the site working. Analytics cookies and similar technologies load
        only after you accept them via our cookie banner. You can change your preference by clearing
        site data for this domain or contacting us. Details are in our Cookie Policy.
      </p>
    ),
  },
  {
    id: 'children',
    title: "Children's privacy",
    body: (
      <p>
        Our services are directed to pet parents and are not intended for children under 18. We do
        not knowingly collect personal information from children.
      </p>
    ),
  },
  {
    id: 'choices',
    title: 'Your choices',
    body: (
      <p>
        You can ask us to access, correct, or delete the information we hold about you, or withdraw
        consent for marketing or analytics where applicable, by writing to{' '}
        <a href="mailto:shekhar@petcart.com" className="text-primary font-medium hover:underline">
          shekhar@petcart.com
        </a>
        . We will respond within a reasonable time.
      </p>
    ),
  },
  {
    id: 'updates',
    title: 'Updates',
    body: (
      <p>
        We may update this policy from time to time. The "Last updated" date at the top of this page
        reflects the latest revision. Continued use of the site after changes means you acknowledge
        the updated policy.
      </p>
    ),
  },
];

const PrivacyPolicy = () => (
  <DocPage title="Privacy Policy" lastUpdated="July 2026" sections={sections} />
);

export default PrivacyPolicy;
